export const styles = {
  label: {
    color: '#000',
    fontSize: 16,
    flex: 1,
  },
};
